/* ============================================================================
   ICH BIN CHRIST — Shopify-Theme-Logik
   ============================================================================
   Verantwortlich für:
     • Splash-Animation auf der Startseite (Überblendung der 4 Farbvarianten)
     • Größenwahl auf der Produktseite (Shopify-Varianten)
     • Warenkorb-Drawer über die Shopify-AJAX-API (/cart.js, /cart/add.js,
       /cart/change.js) — die Kasse ist der echte Shopify-Checkout
     • Scroll-Reveal der Produktinfos

   Kein Framework, keine Abhängigkeiten — reines Vanilla-JS.
   ============================================================================ */

(function () {
  'use strict';

  const SPLASH_INTERVAL_DEFAULT = 1500;   // ms pro Splash-Bild, falls im Editor nichts gesetzt

  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /** Cent-Betrag als deutscher Euro-String, z. B. 3990 → "39,90 €" */
  const formatMoney = (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' €';

  const toggle = (el, show) => { if (el) el.hidden = !show; };


  /* --------------------------------------------------------------------------
     1. DOM-REFERENZEN
     -------------------------------------------------------------------------- */
  const el = {
    header:       $('#site-header'),
    badge:        $('#cart-badge'),

    splash:       $('#screen-home'),
    splashStack:  $('#splash-stack'),
    productsGrid: $('#screen-products'),

    buyBtn:       $('#buy-btn'),
    sizes:        $('#product-sizes'),
    notify:       $('#product-notify'),

    cartOverlay:  $('#cart-overlay'),
    cartDrawer:   $('#cart-drawer'),
    cartEmpty:    $('#cart-empty'),
    cartBody:     $('#cart-body'),
    cartItems:    $('#cart-items'),
    cartSubtotal: $('#cart-subtotal'),
    tplCartItem:  $('#tpl-cart-item'),
  };

  let cartOpen = false;


  /* --------------------------------------------------------------------------
     2. WARENKORB (Shopify-AJAX-API)
     -------------------------------------------------------------------------- */

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  /** Rendert Badge, Zeilen und Zwischensumme aus dem Shopify-Cart-Objekt. */
  function renderCart(cart) {
    el.badge.textContent = cart.item_count;
    toggle(el.badge, cart.item_count > 0);

    const empty = cart.items.length === 0;
    toggle(el.cartEmpty, empty);
    toggle(el.cartBody, !empty);

    const frag = document.createDocumentFragment();
    cart.items.forEach((item) => {
      const node = el.tplCartItem.content.firstElementChild.cloneNode(true);
      node.dataset.key = item.key;
      $('.cart-item__name', node).textContent  = item.product_title;
      $('.cart-item__size', node).textContent  =
        item.variant_title && item.variant_title !== 'Default Title'
          ? 'Größe ' + item.variant_title : '';
      $('.cart-item__count', node).textContent = item.quantity;
            var comparePer = window.PRICE_COMPARE && window.PRICE_COMPARE[item.variant_id];
      var compareEl = $('.cart-item__compare', node);
      if (comparePer && comparePer > item.price) {
        compareEl.textContent = formatMoney(comparePer * item.quantity);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
      $('.cart-item__line', node).textContent  = formatMoney(item.final_line_price);
      if (item.image) {
        $('.cart-item__thumb', node).style.backgroundImage = `url("${item.image}")`;
      }
      frag.appendChild(node);
    });
    el.cartItems.replaceChildren(frag);

    el.cartSubtotal.textContent = formatMoney(cart.items_subtotal_price);
  }

  async function refreshCart() {
    renderCart(await fetchCart());
  }

  function setDrawer(open) {
    cartOpen = open;
    toggle(el.cartOverlay, open);
    toggle(el.cartDrawer, open);
  }

  async function addToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alert(err.description || 'Konnte nicht in den Warenkorb gelegt werden.');
      return;
    }
    await refreshCart();
    setDrawer(true);
  }

  async function changeQty(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    await refreshCart();
  }

  function qtyOf(key) {
    const count = $(`.cart-item[data-key="${CSS.escape(key)}"] .cart-item__count`);
    return count ? Number(count.textContent) : 0;
  }


  /* --------------------------------------------------------------------------
     3. SPLASH-ANIMATION (nur Startseite)
     Die Bild-Ebenen stehen bereits im Liquid-Markup; hier läuft nur der
     Intervall-Wechsel. Klick/Enter blendet Splash aus und Raster ein.
     -------------------------------------------------------------------------- */
  let splashTimer = null;

  function startSplash() {
    const layers = $$('.splash__img', el.splashStack);
    if (layers.length < 2) return;
    // Wechseltempo kommt aus dem Theme-Editor (data-splash-interval)
    const interval = Number(el.splash.dataset.splashInterval) || SPLASH_INTERVAL_DEFAULT;
    let index = layers.findIndex((l) => l.classList.contains('is-active'));
    if (index < 0) { index = 0; layers[0].classList.add('is-active'); }
    splashTimer = setInterval(() => {
      layers[index].classList.remove('is-active');
      index = (index + 1) % layers.length;
      layers[index].classList.add('is-active');
    }, interval);
  }

  function enterShop() {
    clearInterval(splashTimer);
    toggle(el.splash, false);
    toggle(el.productsGrid, true);
    toggle(el.header, true);
    window.scrollTo(0, 0);
  }


  /* --------------------------------------------------------------------------
     4. EVENT-DELEGATION
     Ein einziger Click-Listener wertet [data-action] aus.
     -------------------------------------------------------------------------- */
  function onClick(event) {
    const target = event.target.closest('[data-action]');
    if (!target) return;

    switch (target.dataset.action) {
      case 'enter-shop': enterShop(); break;

      case 'open-cart':  refreshCart(); setDrawer(true); break;
      case 'close-cart': setDrawer(false); break;
      case 'checkout':   window.location.href = '/checkout'; break;

      case 'select-size': {
        $$('.size-btn', el.sizes).forEach((b) =>
          b.classList.toggle('size-btn--active', b === target));
        // Ausverkaufte Größe → Newsletter-Formular statt Kauf-Button
        const soldOut = target.hasAttribute('data-soldout');
        el.buyBtn.dataset.variantId = soldOut ? '' : target.dataset.variantId;
        el.buyBtn.classList.toggle('is-visible', !soldOut);
        toggle(el.buyBtn, !soldOut);
        if (el.notify) {
          toggle(el.notify, soldOut);
          // Tag mit Produkt + Größe → im Admin sieht man, wer worauf wartet
          const tags = $('[name="contact[tags]"]', el.notify);
          if (tags) tags.value = tags.dataset.base + (soldOut ? ', ' + target.dataset.notifyTag : '');
        }
        break;
      }

      case 'add-to-cart': {
        const id = el.buyBtn && el.buyBtn.dataset.variantId;
        if (!id) break;
        // Vorher Hinweis auf die Größentabelle zeigen
        if ($('#size-warning')) toggle($('#size-warning'), true);
        else addToCart(id);
        break;
      }
      case 'confirm-add-to-cart': {
        toggle($('#size-warning'), false);
        const id = el.buyBtn && el.buyBtn.dataset.variantId;
        if (id) addToCart(id);
        break;
      }
      case 'close-size-warning':
        toggle($('#size-warning'), false);
        break;
      case 'goto-size-chart': {
        event.preventDefault();
        toggle($('#size-warning'), false);
        const chart = $('[class*="ai-image-block-"]');
        if (chart) chart.scrollIntoView({ behavior: 'smooth', block: 'center' });
        break;
      }

      // Produktbild: Tipp/Klick wechselt Vorder-/Rückseite (Mobile hat
      // keinen Hover). Nur wenn eine Rückseite existiert.
      case 'toggle-image':
        if (target.querySelector('.media-img--back')) {
          target.classList.toggle('show-back');
        }
        break;

      // Passwortseite: zwischen Newsletter- und Passwort-Ansicht wechseln
      case 'show-password-view':
        toggle($('#pw-view-main'), false);
        toggle($('#pw-view-entry'), true);
        break;
      case 'show-newsletter-view':
        toggle($('#pw-view-entry'), false);
        toggle($('#pw-view-main'), true);
        break;

      case 'qty-inc': {
        const key = target.closest('.cart-item').dataset.key;
        changeQty(key, qtyOf(key) + 1);
        break;
      }
      case 'qty-dec': {
        const key = target.closest('.cart-item').dataset.key;
        changeQty(key, qtyOf(key) - 1);
        break;
      }
      case 'remove-item': {
        const key = target.closest('.cart-item').dataset.key;
        changeQty(key, 0);
        break;
      }
    }
  }


  /* --------------------------------------------------------------------------
     5. INITIALISIERUNG
     -------------------------------------------------------------------------- */
  function init() {
    document.addEventListener('click', onClick);

    // Splash nur, wenn die Startseite ihn mitbringt — sonst Header sofort
    // einblenden (z. B. wenn der Splash im Theme-Editor deaktiviert wurde)
    if (el.splash) {
      startSplash();
      el.splash.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); enterShop(); }
      });
    } else {
      toggle(el.header, true);
    }

    // Theme-Editor: Größentabellen-Pop-up anzeigen, solange die Section
    // ausgewählt ist (sonst wäre es dort nicht zu sehen)
    document.addEventListener('shopify:section:select', (e) => {
      const popup = $('#size-warning', e.target);
      if (popup) toggle(popup, true);
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const popup = $('#size-warning', e.target);
      if (popup) toggle(popup, false);
    });

    // Escape schließt den Drawer
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && cartOpen) setDrawer(false);
      if (e.key === 'Escape') toggle($('#size-warning'), false);
    });

    // Scroll-Reveal der Produktinfos
    const reveals = $$('.reveal');
    if (reveals.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      }, { threshold: 0.25 });
      reveals.forEach((n) => observer.observe(n));
    }

    // Passwortseite: nach falschem Passwort (Reload mit Fehler) direkt
    // die Passwort-Ansicht zeigen statt der Newsletter-Ansicht
    if ($('[data-pw-error]')) {
      toggle($('#pw-view-main'), false);
      toggle($('#pw-view-entry'), true);
    }

    // Produktseite: nach dem Absenden des Ausverkauft-Formulars (Reload)
    // Erfolg/Fehler sichtbar machen statt des Kauf-Buttons
    if (el.notify && $('.newsletter__success, .newsletter__error', el.notify)) {
      toggle(el.notify, true);
      toggle(el.buyBtn, false);
      el.notify.scrollIntoView({ block: 'center' });
    }

    // Badge initial aktualisieren (Liquid rendert den Startwert serverseitig)
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Produkt-Lightbox mit Blättern & Swipe */
(function () {
  var box = document.getElementById('lightbox');
  if (!box) return;
  var imgs = [].slice.call(box.querySelectorAll('.lightbox__img'));
  var current = 0;
  function show(i) {
    current = (i + imgs.length) % imgs.length;
    imgs.forEach(function (img, n) { img.hidden = n !== current; });
  }
  function open(i) { show(i); box.hidden = false; document.body.style.overflow = 'hidden'; }
  function close() { box.hidden = true; document.body.style.overflow = ''; }

  document.querySelectorAll('.product__thumb').forEach(function (btn, i) {
    btn.addEventListener('click', function () { open(i); });
  });
  box.querySelector('.lightbox__next').addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
  box.querySelector('.lightbox__prev').addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
  box.querySelector('.lightbox__close').addEventListener('click', close);
  box.addEventListener('click', function (e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') show(current + 1);
    else if (e.key === 'ArrowLeft') show(current - 1);
  });
  var x0 = null;
  box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  box.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
    x0 = null;
  });
})();
